import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';
import { BillingPlanId } from '@/modules/billing/constants/BillingPlanId';
import { BillingPlanIdMapper } from '@/modules/billing/mappers/BillingPlanIdMapper';
import { FinancialAdvisorProBillingPlanForm } from '@/modules/financialadvisor/models/FinancialAdvisorProBillingPlanForm';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import type { AuthUser } from '@/modules/auth/models/AuthUser';

export class AdvisorCheckoutStarted extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ADVISOR_CHECKOUT_STARTED;

  billingPlan: BillingPlanId | null;
  price: number | undefined;
  userId: number | undefined;

  constructor(plan: FinancialAdvisorProBillingPlanForm, authUser?: AuthUser) {
    super();

    this.billingPlan = BillingPlanIdMapper.getBillingPlanId(plan.productKey as ProductKey);
    this.price = plan.price;
    this.userId = authUser?.id;
  }

  areAllPropertiesRequired(): boolean {
    return false;
  }
}
